// extracted by mini-css-extract-plugin
module.exports = {"bottomDecor":"DecoreLines-module--bottomDecor--2JPyl","bottomDecorLeft":"DecoreLines-module--bottomDecorLeft--3svm5"};